module.exports = __webpack_public_path__ + "media/video.4c5df062.mp4";